import React from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import EsmeConnections from "./EsmeConnections";
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import FormControlLabel from '@mui/material/FormControlLabel';
import RefreshIcon from '@mui/icons-material/Refresh';

function SmppBoxInfo(props) {
  const { data, onRefreshStatus } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return data ? (
    <Accordion style={{ marginTop: 10 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography component="span">
          <Typography
            component="span"
            sx={{ fontSize: 14 }}
            color="textSecondary"
            gutterBottom
          >
            <Typography component="span" variant="h5">
              SMPPBOX{" "}
            </Typography>
            {data.ip}
          </Typography>
          <FormControlLabel
            onClick={event => event.stopPropagation()}
            onFocus={event => event.stopPropagation()}
            control={
              <Button
                style={{ marginLeft: 20 }}
                variant="outlined"
                onClick={handleClick}
                size="small"
              >
                version
              </Button>
            }
            label=""
          />
          <Typography variant="h5" component="h2">
            {data.timestamp}

            <FormControlLabel
              label=""
              onClick={event => event.stopPropagation()}
              onFocus={event => event.stopPropagation()}
              control={
                <Button
                  startIcon={<RefreshIcon />}
                  style={{ marginLeft: 20 }}
                  onClick={onRefreshStatus}
                  size="small"
                  variant="outlined"
                  color="secondary"
                >
                  Refresh
                </Button>
              }
            />
          </Typography>
          <Typography color="textSecondary">
            {data.status}
          </Typography>
        </Typography>
      </AccordionSummary>
      <Box style={{ margin: 25 }}>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          <div style={{ padding: 20 }}>
            <Typography variant="body2" component="p" color="textSecondary">
              {data.version.split("\n").map(e => {
                return (
                  <span key={e}>
                    {e}
                    <br />
                  </span>
                );
              })}
            </Typography>
          </div>
        </Popover>
        <Typography sx={{ mb: 3 }} color="textSecondary">
          bearerbox: received {data.bearerbox.received.total} (queued:{" "}
          {data.bearerbox.received.queued}), sent {data.bearerbox.sent.total}{" "}
          (queued: {data.bearerbox.sent.queued}) PDUs
          <br />
          bearerbox: inbound {data.bearerbox.inbound} PDUs/sec, outbound{" "}
          {data.bearerbox.outbound} PDUs/sec
        </Typography>
        <Typography sx={{ mb: 6 }} color="textSecondary">
          ESME: received {data.esme.received.total} (queued:{" "}
          {data.esme.received.queued}), sent {data.esme.sent.total} (queued:{" "}
          {data.esme.sent.queued}) PDUs
          <br />
          ESME: inbound {data.esme.inbound} PDUs/sec, outbound{" "}
          {data.esme.outbound} PDUs/sec
        </Typography>
        <EsmeConnections
          data={data.sessions}
          logins={data.logins}
        />
      </Box>
    </Accordion>
  ) : null;
}

export default SmppBoxInfo;
